module.exports = __webpack_public_path__ + "images/home_640.jpg";